import React, { useEffect, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/pastDuePerformanceSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import TableWithCustomSearch from "../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import { UpdateButtons } from "./smartComponents/UpdateButtons";
import DatePicker from "./smartComponents/DatePicker";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import { DataPoints } from "./smartComponents/DataPoints";
import PieCharts from "./smartComponents/PieCharts";
import "./pastDuesPerformance.scss";
import { PdcTypeFilter } from "./smartComponents/PdcTypeFilter";
import { PaymentStatusFilter } from "./smartComponents/PaymentStatusFilter";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";

const PastDuesPerformanceModule = (props) => {
  const dispatch = useDispatch();

  const initialRequest = useSelector((state) => state.pastDuesPerformance.initialRequest);
  const isLoading = useSelector((state) => state.pastDuesPerformance.isLoading);
  const updatesLoading = useSelector((state) => state.pastDuesPerformance.updatesLoading);

  const { data, colHeaders, columns, rawDataLink } = useSelector(
    (state) => state.pastDuesPerformance.chartsData.table
  );

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = (
    <div>
      <div id="override-edit-selection-bar" className="edit-selections-bar">
        <div className="top-filter">
          <div className="top-filter__left">
            <PdcTypeFilter />
            <PaymentStatusFilter />
          </div>
          <div />
          <div className="top-filter__right">
            <div className="select-box-no-width date-range-select-box">
              <p>Date Range</p>
              <CustomDateRanges />
            </div>

            <div className="date-select-box multi">
              <p>Date</p>
              <DatePicker />
            </div>
          </div>
        </div>

        <UpdateButtons />
      </div>
      <div data-testid="charts-container" className="chart-root">
        {updatesLoading ? (
          <LoadingAnimation text="Updating data..." />
        ) : (
          <>
            <DataPoints />
            <PieCharts />

            <TableWithCustomSearch
              fileName="past-dues"
              data={data}
              columns={columns}
              colHeaders={colHeaders}
              rawDataLink={rawDataLink}
              itemsPerPage={10}
            />
          </>
        )}
      </div>
    </div>
  );

  return (
    <div id="module-date-filters">
      <div id="past-dues-performance">
        <SectionToggle
          height={690}
          title="Past Due Performance"
          isLoading={isLoading}
          content={content}
          learnMore={
            <KBLearnMore
              title="Past Due Performance"
              description="This report shows past-due revenue and aging periods, giving you visibility into outstanding balances and potential risk areas. These insights help you protect your bottom line, identify overdue accounts, and take proactive steps to improve billing efficiency."
              kbUrl={ILEARN_URLS.salesRevenue.pastDuePerformance}
            />
          }
        />
      </div>
    </div>
  );
};

export default memo(PastDuesPerformanceModule);
